<template lang="pug">
.pending-approval
  HScroll(:currentStep='currentStep')
    transition(name='simple-fade' mode='out-in')
      //- STEP 1 (always visible)
      PendingApprovalList(
        @itemClicked='entrySelected'
        :shouldRefresh='shouldRefreshOrderList'
        @finishLoading='shouldRefreshOrderList = false'
      )
      //- CustomerChooser(v-model='customer' @input='setCurrentStep(STEP_SELECT_ENTRY)')

    transition(name='simple-fade' mode='out-in')
      //- STEP 2 (visible if customer is selected)
      .d-flex.p-0(v-if='selectedEntry')
        //- CustomerInsight(:data='customer')
        AdminEntryDetail(
          :entryDetail='selectedEntry'
          @actionPerformed='orderActionPerformed'
        )
        ActionSelectorMenu(:items='actionItems' v-model='actionType')

    transition(name='simple-fade' mode='out-in')
      //- STEP 3 (visible if actionType is selected)
      div(v-if='actionType')
        template(v-if='actionType === "PAYMENT_HISTORY"')
          PaymentHistory(:customer='customer')
        template(v-else-if='actionType === "PURCHASE_HISTORY"')
          PurchaseHistory(:customer='customer')
        template(v-else-if='actionType === "PRODUCT_PURCHASE_HISTORY"')
          ProductPurchaseHistory(:customer='customer')

        template(v-else)
          GenericCard.actionDetail(size='33')
            .d-flex.flex-column.px-3.py-4
              h5 {{ actionType }}

</template>

<script>
import PendingApprovalList from '@/components/_admin/pending-approval/panels/PendingApprovalList.vue';
// import CustomerChooser from '@/components/customers/CustomerChooser.vue';
import AdminEntryDetail from '@/components/_admin/pending-approval/panels/entry-detail/AdminEntryDetail.vue';
// import CustomerInsight from '@/components/customers/CustomerInsight.vue';

import PaymentHistory from '@/components/_cs/customer-history/panels/PaymentHistory.vue';
import PurchaseHistory from '@/components/_cs/customer-history/panels/PurchaseHistory.vue';
import ProductPurchaseHistory from '@/components/_cs/customer-history/panels/ProductPurchaseHistory.vue';

export default {
  data: () => ({
    selectedEntry: null,
    customer: null,
    actionType: null,
    checkinActionType: null,
    // actionDetail: null,
    currentStep: 0,

    filterProvince: '',

    STEP_SELECT_ENTRY: 1,
    STEP_SELECT_ACTION: 2,
    STEP_SELECT_CHECKIN_ACTION: 3,

    actionItems: {
      PAYMENT_HISTORY: 'ประวัติการชำระเงิน',
      PURCHASE_HISTORY: 'ประวัติรายการซื้อ',
      PRODUCT_PURCHASE_HISTORY: 'ประวัติสินค้าที่ซื้อ',
    },

    shouldRefreshOrderList: true,
  }),
  watch: {
    selectedEntry(newVal) {
      if (newVal) {
        this.setCurrentStep(this.STEP_SELECT_ENTRY);
        this.customer = this.selectedEntry.customer;
      }
    },
    actionType(newVal) {
      if (newVal) {
        this.setCurrentStep(this.STEP_SELECT_ACTION);
      }
    },
  },
  computed: {
    isActionDetailsValid() {
      return this.receiptType !== -1
          && this.deliveryType !== -1
          && this.shipmentMethod !== -1;
    },
  },
  mounted() {
    const { order } = this.$route.params;
    if (order) {
      this.selectedEntry = order;
    }
  },
  methods: {
    setCurrentStep(step) {
      // change step to step - 1 => wait 50ms => change step to the actual value
      // so the change is always noticed by the HSrcoll component
      // HSroll will then scoll to the right, so the new view is visible to the user
      this.currentStep = step - 1;
      setTimeout(() => {
        this.currentStep = step;

        //
        // 1. PREPARE the data for each STEP
        // 2. RESET the data gathered from further steps
        //    so the data won't be mixed up
        //

        // STEP 1
        if (step < this.STEP_SELECT_ENTRY) {
          // ..
          this.selectedEntry = null;
        }

        // STEP 2
        if (step < this.STEP_SELECT_ACTION) {
          this.actionType = null;
        }
      }, 50);
    },

    entrySelected(e) {
      this.selectedEntry = e;
    },

    orderActionPerformed() {
      this.setCurrentStep(0);
      this.shouldRefreshOrderList = true;
    },
  },
  components: {
    PendingApprovalList,
    // CustomerInsight,
    AdminEntryDetail,

    PaymentHistory,
    PurchaseHistory,
    ProductPurchaseHistory,
  },
};
</script>

<style lang="scss">
.pending-approval {
  > .h-scroll {
    height: 100%;
  }
}
</style>
